﻿var TSPCashOutSinglePurchase = (function ()
{
    'use strict';
    var api = {};

    return api;
}());

window.TSPCashOutSinglePurchase = TSPCashOutSinglePurchase;